module.exports = __webpack_public_path__ + "img/search-icon.7d569710.svg";